import { render, staticRenderFns } from "./StudentEdit.vue?vue&type=template&id=d7529a4c&scoped=true&lang=pug&"
import script from "./StudentEdit.vue?vue&type=script&lang=ts&"
export * from "./StudentEdit.vue?vue&type=script&lang=ts&"
import style0 from "./StudentEdit.vue?vue&type=style&index=0&id=d7529a4c&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7529a4c",
  null
  
)

export default component.exports